import React from 'react';
import HockeyGallery from './HockeyGallery';

export default function CamelsGallery() {
  return (
    <HockeyGallery
      collection="camels"
      title="🐪 Camels Hockey Club"
      subtitle="Photos & Media"
      accentColor="#E87722"
      darkBg="#1a1a1a"
    />
  );
}
